module.exports = __webpack_public_path__ + "img/7.3abd6253.jpg";